import Modal from 'components/commons/modal/Modal2';
import React from 'react';

export const AboutDataUpdateTimingModal = ({
  hide,
  isShowModal,
}: {
  isShowModal: boolean;
  hide: () => void;
}): React.ReactElement => {
  return (
    <>
      <Modal {...{ isShow: isShowModal, close: hide }}>
        <div className={`max-h-modal overflow-y-auto flex flex-col p-4`}>
          <div className="flex flex-row mb-4">
            <div className={`text-bluegray-700 font-bold text-lg`}>
              データ更新のタイミングについて
            </div>
            <div
              className="icon-close text-bluegray-400 ml-auto text-lg cursor-pointer"
              onClick={hide}></div>
          </div>
          <div className="mb-3">
            証券口座のデータは平日の18：00以降に取得します。証券会社や取引データの量により反映までお時間がかかることがあります。データの反映まで、しばらくお待ちください。
            <br />
            <br />
            データの更新が出来なかった場合は、翌日に再度更新処理を行います。更新の失敗が続く場合は、ご登録いただいている証券口座情報を確認してください。
          </div>
          <button
            onClick={hide}
            className="bg-white pt-4 px-8 text-gray-500 text-base flex justify-center items-center">
            閉じる
          </button>
        </div>
      </Modal>
    </>
  );
};
